<script lang="ts" setup>
import Timer from '@/components/Timer.vue'

interface Props {
  baslamasinaKalanSure: number
  yonergeOnaylandiMi: boolean
}

defineProps<Props>()
</script>

<template>
  <div
    class="card w-full p-3 space-y-2 flex md:flex-col flex-row items-center justify-between md:justify-center px-4 md:px-6"
  >
    <span class="text-body-md text-gray-400 md:mb-4 mb-0"> {{ $t('exam_start_text') }} </span>

    <div class="md:w-30 md:h-30 w-1/2 h-10">
      <Timer :time="baslamasinaKalanSure" class="w-full h-full" :active="yonergeOnaylandiMi" />
    </div>
  </div>
</template>
